import type * as lazyIndex from "./lazyIndex";
import { LazyAction, LazyModule } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "NativeOutlookHost"*/ "./lazyIndex"), { name: "NativeOutlookHost" });

export const lazyGetHostCapabilitiesProxy: LazyAction<typeof lazyIndex.getHostCapabilitiesProxy, typeof lazyModule> = new LazyAction(lazyModule, m => m.getHostCapabilitiesProxy);
